import { useState } from 'react';
import { AText, Box } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const BannerImage = ({
  isTournamentYouAreLabelInShown,
  defaultPromoImage,
  promoImage
}) => {
  const [isError, setIsError] = useState(false);
  const { t } = useI18n();
  const { isMobile } = useDeviceStore();

  const imageSrc =
    (isError ? defaultPromoImage : promoImage) || defaultPromoImage;

  return (
    <Box className={styles.bannerImageWrapper}>
      {isTournamentYouAreLabelInShown && (
        <Box
          className={styles.bannerImageYouAreInLabelWrapper}
          padding={isMobile ? 'xs s xs xs' : 's m s s'}
          align="center"
        >
          <Box margin={isMobile ? '0 s 0 0' : '0 m 0 0'}>
            <Icon
              name="icons/general/state/success"
              size={isMobile ? 'xs' : 'l'}
              color="txt_color_4"
            />
          </Box>
          <AText breed="BU" size={isMobile ? 'l' : '2xl'} color="txt_color_4">
            {t('web.promo.tag.youAreIn')}
          </AText>
        </Box>
      )}
      <img
        src={imageSrc}
        onError={() => setIsError(true)}
        alt="promoImage"
        data-role="promotion-item-banner"
        className={styles.image}
      />
    </Box>
  );
};
